const ON_CLICK_FUNC = (e) => e.stopPropagation();
const FONTS = 'FuturaBold, "Futura", sans-serif';

export const BAR_CHART_OPTIONS = {
  layout: {
    padding: {
      top: 50
    }
  },
  plugins: {
    legend: {
      display: false,
      onClick: ON_CLICK_FUNC
    }
  },
  scales: {
    x: {
      grid: {
        drawOnChartArea: false
      }
    },
    y: {
      grid: {
        drawOnChartArea: false,
      }
    }
  }
};

export const LEGEND_CONFIG = {
  plugins: {
    legend: {
      position: 'right',
      onClick: ON_CLICK_FUNC,
      labels: {
        font: {
          family: FONTS,
          style: 'bold',
        },
        fontColor: '#000',
        usePointStyle: true
      }
    }
  }
};


export const LEGEND_CONFIG_BAR = {
  scales: {
    x: {
      grid: {
        drawOnChartArea: false
      }
    },
    y: {
      grid: {
        drawOnChartArea: false,
      }
    }
  },
  plugins: {
    legend: {
      position: 'right',
      onClick: ON_CLICK_FUNC,
      labels: {
        font: {
          family: FONTS,
          style: 'bold',
        },
        fontColor: '#000',
        usePointStyle: true
      }
    }
  }
};

export const DOUGHNUT_CHART_OPTIONS = {
  plugins: {
    legend: {
      position: 'right',
      onClick: ON_CLICK_FUNC,
      labels: {
        font: {
          family: FONTS,
          style: 'bold',
        },
        fontColor: '#000',
        usePointStyle: true
      }
    }
  }
};

export const LINE_CHART_OPTIONS = {
  plugins: {
    legend: {
      position: 'right',
      labels: {
        font: {
          family: FONTS,
          style: 'bold',
        },
        fontColor: '#000',
        usePointStyle: true
      }
    },
    scales: {
      x: {
        grid: {
          drawOnChartArea: false
        }
      },
      y: {
        grid: {
          drawOnChartArea: false,
        }
      }
    }
  }
};

export const BENEFICIARY_CHART_OPTIONS = {
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    legend: {
      position: 'right',
      onClick: ON_CLICK_FUNC,
      labels: {
        font: {
          family: FONTS,
          style: 'bold',
        },
        fontColor: '#000',
        usePointStyle: true
      }
    }
  }
};
